export default __webpack_public_path__ + "static/oyasync_logo-76156d8a6e39a4c3702b82ac4acad4df.svg";